<template>
  <div class="main container-fluid admin-shell">
    <header class="admin-shell__hero">
      <div>
        <h4 class="admin-shell__title mb-1">Администрирование</h4>
        <p class="admin-shell__subtitle mb-0">Управление пользователями, стримами, AI-профилями, статистикой и системными настройками</p>
      </div>
    </header>

    <section class="px-3 pb-2">
      <div class="admin-shell__tabs">
        <router-link class="admin-shell__tab" :class="{ active: isActive('/admin/statistics') }" to="/admin/statistics">Статистика</router-link>
        <router-link class="admin-shell__tab" :class="{ active: isActive('/admin/users') }" to="/admin/users">Пользователи</router-link>
        <router-link class="admin-shell__tab" :class="{ active: isActive('/admin/streams') }" to="/admin/streams">Стримы</router-link>
        <router-link class="admin-shell__tab" :class="{ active: isActive('/admin/ai-profiles') }" to="/admin/ai-profiles">AI-профили</router-link>
        <router-link class="admin-shell__tab" :class="{ active: isActive('/admin/properties') }" to="/admin/properties">Свойства</router-link>
        <router-link
          class="admin-shell__tab"
          :class="{ active: isActive('/admin/stream-settings') }"
          to="/admin/stream-settings"
        >
          Настройки стримов
        </router-link>
        <router-link
          class="admin-shell__tab"
          :class="{ active: isActive('/admin/ai-pricing') }"
          to="/admin/ai-pricing"
        >
          Цены LLM
        </router-link>
        <router-link class="admin-shell__tab" :class="{ active: isActive('/admin/rss') }" to="/admin/rss">RSS</router-link>
        <router-link class="admin-shell__tab" :class="{ active: isActive('/admin/invites') }" to="/admin/invites">Инвайты</router-link>
      </div>
    </section>

    <router-view />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()

const isActive = path => {
  const currentPath = route.path || ''
  return currentPath === path || currentPath.startsWith(`${path}/`)
}
</script>

<style scoped>
.admin-shell {
  min-height: 100%;
  padding-top: 10px;
  background:
    radial-gradient(circle at 2% 3%, rgba(66, 153, 225, 0.2), transparent 36%),
    radial-gradient(circle at 98% 2%, rgba(56, 189, 248, 0.18), transparent 32%),
    #f3f7ff;
}

.admin-shell__hero {
  margin: 0 20px 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(135deg, #122a55 0%, #1d4d92 60%, #226fc1 100%);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 18px 40px rgba(16, 48, 95, 0.22);
}

.admin-shell__title {
  font-weight: 800;
  letter-spacing: 0.01em;
}

.admin-shell__subtitle {
  color: rgba(232, 242, 255, 0.92);
  font-size: 13px;
}

.admin-shell__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  border-radius: 14px;
  border: 1px solid #dce7fa;
  background: #fff;
  padding: 10px;
}

.admin-shell__tab {
  text-decoration: none;
  border-radius: 999px;
  border: 1px solid #d4e2f7;
  background: #f7fbff;
  color: #2d507e;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 10px;
}

.admin-shell__tab.active {
  color: #fff;
  border-color: #2f65ad;
  background: linear-gradient(135deg, #1f4f8f, #2d6fba);
}

@media (max-width: 992px) {
  .admin-shell__hero {
    margin: 0 12px 12px;
    padding: 12px;
  }
}
</style>
